import { api } from "./api";

export async function validateToken(accountName, token) {
  const response = await api.get(`session-api.php?validate_token=${accountName}&token=${token}`);
  return response.data;
}